/**
 * Türkçe büyük harf (TR locale). Form gönderimlerinde ad, soyad, firma, plaka için kullanın.
 */
export function trUpper(s: string | undefined): string | undefined {
  if (s == null || s === '') return s;
  return String(s).toLocaleUpperCase('tr-TR');
}

/**
 * Ant Design Form.Item normalize için: yazarken Türkçe büyük harfe çevirir (ad, soyad, firma, plaka).
 */
export function trUpperNormalize(value: any): any {
  if (value == null || value === '') return value;
  return String(value).toLocaleUpperCase('tr-TR');
}

/**
 * Türkçe arama için normalize: "İhsan" ve "ihsan" aynı sonucu verir (sunucu dili İngilizce olsa da).
 * İ -> i, I -> i, ı -> i dönüşümü ile locale'dan bağımsız eşleşme.
 */
export function trLower(s: string | undefined): string {
  if (s == null) return '';
  const t = String(s);
  return t
    .replace(/\u0130/g, 'i')  // İ (U+0130) -> i
    .replace(/\u0049/g, 'i')  // I (ASCII) -> i
    .toLowerCase()
    .replace(/\u0131/g, 'i'); // ı (U+0131) -> i
}
